import { Container, PageHeader } from '@vnetwork/ui/layout';
import { ItemsListSection } from './items-list-section';

/**
 * Inventory list — the unified equipment + component register (legacy Warehouse
 * Items). A `PageHeader` over the server-paginated `ItemsListSection`, which
 * carries the category count-cards, the type / status / condition / owner /
 * location / supplier / model filters, search and CSV export. Read-only.
 */
export default function CapacityItemsPage() {
  return (
    <Container size="full">
      <PageHeader
        title="Inventory"
        description="All equipment and components in the warehouse — pick a category, refine with the filters, and export the current view."
        style={{ marginBottom: 'var(--vn-space-4)' }}
      />
      <ItemsListSection />
    </Container>
  );
}
